import {CompanyConfig} from '../types';
import {baseRoles, mergeWithDefaults} from './base.config';

const {labels, features, roles} = mergeWithDefaults(
  {
    order: 'Order',
    orders: 'Orders',
    customer: 'Customer',
    customers: 'Customers',
    dispatch: 'Dispatch',
  },
  {
    hasShopifyIntegration: true,
    hasMergeOrdersOnOrderList: true,
  },
  baseRoles
);

export const deliveryManagerConfig: CompanyConfig = {
  type: 'delivery_manager',
  labels,
  features,
  roles,
};
